// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ed6PkWGLmx9J0S {
  display: inline-flex;
  height: 32px;
  margin: var(--ds-space-0, 0);
  float: left;
  line-height: 32px;
  white-space: nowrap;
}
.clF9_b5nMUvjxu {
  display: flex;
}
.clF9_b5nMUvjxu > div:last-child {
  flex-shrink: 0;
}
.PBJZkd9ks05eX_ {
  background-color: var(--dynamic-button);
  color: var(--dynamic-text);
  position: relative;
  flex-shrink: 0;
  min-width: 32px;
  max-width: 400px;
  height: 32px;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
  float: left;
  overflow: hidden;
  border-radius: 3px;
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 32px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.PBJZkd9ks05eX_ svg circle {
  stroke: var(--dynamic-icon);
}
.PBJZkd9ks05eX_.nIVf1Grg2yfkZ8 .rfkl4STWNUSqrb {
  margin-right: var(--ds-space-0, 0);
}
.PBJZkd9ks05eX_.VwOksS_8lAPfw0 {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.PBJZkd9ks05eX_.VwOksS_8lAPfw0 svg circle {
  stroke: var(--dynamic-icon);
}
.PBJZkd9ks05eX_.VwOksS_8lAPfw0:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.PBJZkd9ks05eX_:hover {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
  text-decoration: none;
}
.PBJZkd9ks05eX_:hover svg circle {
  stroke: var(--dynamic-icon);
}
.PBJZkd9ks05eX_:active {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-pressed);
  color: var(--dynamic-button-pressed-text);
}
.PBJZkd9ks05eX_:active svg circle {
  stroke: var(--dynamic-icon);
}
@media only screen and (max-width: 900px) {
  .PBJZkd9ks05eX_ {
    color: var(--dynamic-text);
    position: relative;
    flex-shrink: 0;
    min-width: 32px;
    max-width: 400px;
    height: 32px;
    margin: var(--ds-space-0, 0) 5px var(--ds-space-050, 4px) var(--ds-space-0, 0);
    padding: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
    float: left;
    overflow: hidden;
    border-radius: 3px;
    font-size: 14px;
    line-height: 32px;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
  .PBJZkd9ks05eX_ svg circle {
    stroke: var(--dynamic-icon);
  }
  .PBJZkd9ks05eX_:hover {
    background-color: var(--dynamic-button-hovered);
    color: var(--dynamic-text);
    text-decoration: none;
  }
  .PBJZkd9ks05eX_:hover svg circle {
    stroke: var(--dynamic-icon);
  }
}
.nIVf1Grg2yfkZ8 {
  min-width: 16px;
  text-overflow: unset;
}
.nIVf1Grg2yfkZ8 .KREm55LvPcmikM {
  display: none;
}
.H7XJuvqCPgjbkK {
  min-width: 32px;
  height: 32px;
  padding: var(--ds-space-075, 6px);
}
.H7XJuvqCPgjbkK .loa0NXlLSQ0G1C {
  margin-left: var(--ds-space-0, 0);
}
.H7XJuvqCPgjbkK.VwOksS_8lAPfw0 {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.H7XJuvqCPgjbkK.VwOksS_8lAPfw0 svg circle {
  stroke: var(--dynamic-icon);
}
.H7XJuvqCPgjbkK.VwOksS_8lAPfw0:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.JgD5Q69VLLZuvf {
  min-width: 54px;
}
.rfkl4STWNUSqrb {
  width: 20px;
  margin-right: var(--ds-space-075, 6px);
}
.hEfHsu8iVCP6Jo {
  position: absolute;
  z-index: -1;
  width: 32px;
  height: 32px;
}
.DtOALKJEZCMtln h1 {
  font-size: 16px;
  line-height: 20px;
}
.DtOALKJEZCMtln p {
  font-size: 14px;
  line-height: 20px;
}
.cQkLyTN7xkXebW {
  margin-right: var(--ds-space-100, 8px);
}
@media only screen and (min-width: 1281px) {
  .cQkLyTN7xkXebW {
    display: none;
  }
}
@media only screen and (max-width: 1280px) {
  .zKilmsoIESXoGR {
    display: none;
  }
}
.U_G0pjxcy4Y7ZV {
  margin-bottom: var(--ds-space-150, 12px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewSwitcherContainer": `Ed6PkWGLmx9J0S`,
	"switcherButtonsContainer": `clF9_b5nMUvjxu`,
	"viewSwitcherButton": `PBJZkd9ks05eX_`,
	"collapsed": `nIVf1Grg2yfkZ8`,
	"viewSwitcherIcon": `rfkl4STWNUSqrb`,
	"highlighted": `VwOksS_8lAPfw0`,
	"buttonText": `KREm55LvPcmikM`,
	"overflowButton": `H7XJuvqCPgjbkK`,
	"downIcon": `loa0NXlLSQ0G1C`,
	"overflowButtonLarge": `JgD5Q69VLLZuvf`,
	"dummyPopoverTarget": `hEfHsu8iVCP6Jo`,
	"spotlight": `DtOALKJEZCMtln`,
	"hideOnNormalScreens": `cQkLyTN7xkXebW`,
	"showOnNormalScreens": `zKilmsoIESXoGR`,
	"premiumBanner": `U_G0pjxcy4Y7ZV`
};
export default ___CSS_LOADER_EXPORT___;
